import { render, staticRenderFns } from "./numbered-pagination.vue?vue&type=template&id=ab2c6fb6&"
import script from "./numbered-pagination.vue?vue&type=script&lang=ts&"
export * from "./numbered-pagination.vue?vue&type=script&lang=ts&"
import style0 from "./numbered-pagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports